import React from "react";
import { getProperDate } from "../../util";
import { HeaderDivider } from "../../common/components/HeaderDivider";
import { CommissionHeaders } from "../../common/components/SectionHeader";
import "../../components/Purchases/Disclosure.css";

const DisclosureModal = props => {
	if (props.type === "DisclosureReadonly") {
	if (props.createFormState.correctiveEvents.length > 0) {
		props.createFormState.corrective_events =
		props.createFormState.correctiveEvents;
		props.createFormState.corrective_events.map(
		res => (res.date = res.disclosureDate)
		);
	}
	}
	return (
	<React.Fragment>
		<div className="m-t-20">
		{props.type !== "DisclosureReadonly" ? (
			<React.Fragment>
			<CommissionHeaders>
				Commission Severity Report
			</CommissionHeaders>
			<HeaderDivider />
			<div className="fullwidth" id={"commission-report-basic-data"}>
				<div className="name-width">
				<div className={"commission-input-label"}>
					Severity Report Name
				</div>
				<input
					tabIndex="-1"
					className={"commission-input fullwidth"}
					value={props.createFormState.commission_name}
					placeholder="Severity Report Name"
					readOnly
				/>
				</div>
				<div className="ticker-width">
				<div className={"commission-input-label"}>Ticker</div>
				<input
					tabIndex="-1"
					className={"commission-input fullwidth"}
					value={props.createFormState.ticker}
					placeholder="Ticker"
					readOnly
				/>
				</div>
				<div className="startdt-width">
				<div className={"commission-input-label"}>Class Period Start Date</div>
				<input
					tabIndex="-1"
					className={"commission-input fullwidth"}
					value={getProperDate(
					props.createFormState.class_start_period
					)}
					placeholder="Class Period Start Date"
					readOnly
				/>
				</div>
				<div className="enddt-width">
				<div className={"commission-input-label"}>Class Period End Date</div>
				<input
					tabIndex="-1"
					className={"commission-input fullwidth"}
					value={getProperDate(props.createFormState.class_end_period)}
					placeholder="Class Period End Date"
					readOnly
				/>
				</div>
			</div>
			</React.Fragment>
		) : null}
		<div id={"corrective-events-holder"}>
			<CommissionHeaders>Alleged Corrective Events</CommissionHeaders>
			<HeaderDivider />
			<div>
			{/* props.createFormState.corrective_events */}
			<table id="comissionCreateTable">
				<thead>
				<tr>
					<th> Corrective Disclosure / Adverse Event</th>
					<th style={{paddingLeft:10}}> Percentage</th>
					<th></th>
				</tr>
				</thead>
				<tbody>
				{props.createFormState.corrective_events.map((res, index) => {
					return (
					<tr key={index}>
						<td>
						<input
							tabIndex="-1"
							className={"commission-corrective-event-input"}
							placeholder={
							"Select date"
							}
							readOnly
							value={getProperDate(res.date)}
						/>
						</td>
						<td>
						<div className="d-flex">
							<div>
							<input
								tabIndex="-1"
								readOnly
								className={"percentage-input"}
								placeholder={"%"}
								value={res.percentage+'%'}
							/>
							</div>
						</div>
						</td>
					</tr>
					);
				})}
				</tbody>
			</table>
			</div>
			<div className="m-t-20">
			<div className={"commission-input-label"}>Notes</div>
			<textarea
				tabIndex="-1"
				readOnly
				className={"commission-input"}
				value={props.createFormState.notes}
				cols={30}
				rows={2}
				placeholder={"Notes"}
			/>
			</div>
		</div>
		</div>
	</React.Fragment>
	);
};

export default DisclosureModal;



// WEBPACK FOOTER //
// ./src/commissions/components/DisclosureModal.js